import { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

import {
  delete_active_from_id,
  edit_active_from_id,
  load_active_data_from_id,
  upload_active,
} from "../../actions/management_content";
import { hasPermission } from "../../hooks/userPermissions";

const CreateActiveModal = (props) => {
  const { show, onHide, activeId, activeType, user } = props;
  const initialActiveData = {
    name: "",
    details: "",
    active_type: activeType.optionName,
    price: "",
  };
  const [activeData, setActiveData] = useState(initialActiveData);
  const [formAlerts, setFormAlerts] = useState({
    name: false,
    active_type: false,
    price: false,
  });

  const checkEmptyFields = (keyList) => {
    let isEmpty = false;
    const newFormData = { ...activeData };
    keyList.forEach((key) => {
      if (activeData[key].toString().trim() === "") {
        formAlerts[key] = true;
        isEmpty = true;
      } else {
        formAlerts[key] = false;
      }

      setTimeout(() => {
        setFormAlerts({ name: false, active_type: false, price: false });
      }, 3500);
    });

    setActiveData(newFormData);
    return isEmpty;
  };
  const fetchActiveData = async () => {
    const data = await load_active_data_from_id(activeId);
    if (data) {
      setActiveData(data);
    }
  };

  const handleUpload = () => {
    if (!checkEmptyFields(["name", "active_type", "price"])) {
      upload_active(activeData);
      onHide();
    }
  };
  const handleUploadEdit = () => {
    if (!checkEmptyFields(["name", "active_type", "price"])) {
      edit_active_from_id(activeId, activeData);
      onHide();
    }
  };
  const handleDelete = () => {
    delete_active_from_id(activeId);
    onHide();
  };

  const handleChange = (e) => {
    setActiveData({ ...activeData, [e.target.name]: e.target.value });
  };
  const submitButtons = {
    create: () => (
      <Button variant="primary" onClick={handleUpload}>
        Agregar
      </Button>
    ),
    edit: () => (
      <Button variant="primary" onClick={handleUploadEdit}>
        Guardar Cambios
      </Button>
    ),
  };
  useEffect(() => {
    const fetchData = async () => {
      if (activeId) {
        await fetchActiveData(activeId); // Fetch quote data only after fetchQuoteOptions finishes
      } else {
        setActiveData(initialActiveData);
      }
    };

    fetchData();
  }, [show, activeId]);

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header className="justify-content-center">
        <Modal.Title>
          {activeId ? "Editar" : "Agregar"} {activeType.title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="quote-modal-body d-flex flex-column gap-2">
          <div className="input-field">
            <label
              htmlFor="quoteHourFormControlInput"
              className="form-label mb-1"
            >
              Nombre
              <strong className="text-danger">*</strong>
              <span
                className={
                  formAlerts.name ? "fst-italic m-2 text-danger" : "d-none"
                }
              >
                No valido.
              </span>
            </label>
            <input
              onChange={(e) => handleChange(e)}
              value={activeData.name}
              type="text"
              name="name"
              className={
                formAlerts.name
                  ? "border border-danger form-control"
                  : "form-control"
              }
              id="quoteHourFormControlInput"
            />
          </div>

          <div className="input-field">
            <label htmlFor="exampleFormControlTextarea1" className="form-label">
              Descripcion
            </label>
            <textarea
              className="form-control"
              id="exampleFormControlTextarea1"
              rows={3}
              name="details"
              onChange={(e) => handleChange(e)}
              value={activeData.details}
            />
          </div>

          <div className="row">
            <div className="input-field col">
              <label
                htmlFor="addressFormControlInput"
                className="form-label mb-1"
              >
                Tipo de activo
                <strong className="text-danger">*</strong>
                <span
                  className={
                    formAlerts.active_type
                      ? "fst-italic m-2 text-danger"
                      : "d-none"
                  }
                >
                  No valido.
                </span>
              </label>
              <select
                className={
                  formAlerts.active_type
                    ? "border border-danger form-select"
                    : "form-select"
                }
                aria-label="Default select example"
                name="active_type"
                value={activeData.active_type}
                onChange={(e) => handleChange(e)}
              >
                <option value="service">Servicio</option>
                <option value="product">Producto</option>
                <option value="rent">Arriendo</option>
                <option value="salary">Remuneracion</option>
                <option value="bank">Banco</option>
                <option value="other">Otro</option>
              </select>
            </div>
            {/* <div className="input-field col">
              <label
                htmlFor="addressFormControlInput"
                className="form-label mb-1"
              >
                Subcategoria
              </label>
              <select
                className="form-select"
                aria-label="Default select example"
                name="subcategory"
                value={activeData.subcategory}
                onChange={(e) => handleChange(e)}
              >
                <option value="">Sin subcategoría</option>
                {subcategoryList[activeData.active_type]?.map((item) => (
                  <option value={item.id} key={item.id}>
                    {item.name}
                  </option>
                ))}
              </select>
            </div> */}
          </div>
          <div className="input-field">
            <label
              htmlFor="quoteHourFormControlInput"
              className="form-label mb-1"
            >
              Precio
              <strong className="text-danger">*</strong>
              <span
                className={
                  formAlerts.price ? "fst-italic m-2 text-danger" : "d-none"
                }
              >
                No valido.
              </span>
            </label>
            <input
              onChange={(e) => handleChange(e)}
              value={activeData.price}
              type="number"
              name="price"
              className={
                formAlerts.price
                  ? "border border-danger form-control"
                  : "form-control"
              }
              id="quoteHourFormControlInput"
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="justify-content-between">
        {activeId && hasPermission(user, "delete:active") && (
          <Button variant="danger" onClick={(e) => handleDelete()}>
            Eliminar
          </Button>
        )}
        <div className="d-flex flex-fill justify-content-end gap-2">
          <Button variant="secondary" onClick={onHide}>
            Cerrar
          </Button>
          {activeId
            ? hasPermission(user, "update:active") && submitButtons.edit()
            : hasPermission(user, "create:active") && submitButtons.create()}
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default CreateActiveModal;
